/**
 * @created : 2021/3/23
 * @author  : 王冲
 * @desc    : 导航各类菜单store
 */

import { action, observable, runInAction, toJS } from 'mobx';
import * as _ from "lodash-es";

import { mockData } from '../../../../mock';
import { appMenuGroupType, appMenuItemType, MailTypesMenuKeyMap, MenuType, QuickMenuItemType, QuickSearchItem } from '../types';
import * as API from '../../../../api/getListData';
import * as mainAPI from "../../../../api/mainApi";
import {
  canCreateTeams,
  clearCookieByName,
  controlGroupData, filterApp,
  getMaxLengthSameStr, hideHelp, inPCClient, isE10Self, isFirefox,
  isPreview, isPreviewToolMenu,
  isPrivateEnv, isProductEnv, needShowIvite, needShowLogout, needShowTenant,
  RoutePathControlByOther,
  setBrowserTitle,
  updateMenuInfoData
} from "../../../../utils";
import { Dialog, IconSelection } from "@weapp/ui";
import mainStore from '../../../main/store';
import { getLabel } from "@weapp/utils";
import { IconShowType, QuickMenuType, NavMenuItem } from "../widgets/quickToolbar/types";
import { headerClsPrefix, hiddenNavigationList, layoutPublicStatic, layoutPublicUrl } from '../../../../constants';
import { SearchShowType } from "../../types";
import { LayoutSDK } from "../../../../lib";

const { message } = Dialog;
const { getIconInfo } = IconSelection;

const filterMainNav = (data: NavMenuItem[]) => {
  let visibleMap = {
    "quick_create": { visible: !window.inExternalSpace },  //快捷新增
    "quick_center": { visible: !(isPrivateEnv() && hideHelp()) },  //服务中心
    "quick_concern": {   //待办/关注/标签 121579
      visible: !window.inExternalSpace && (
        window.TEAMS?.isDisplayModule?.("wait") ||
        window.TEAMS?.isDisplayModule?.("watch") ||
        window.TEAMS?.isDisplayModule?.("tag")
      )
    },
    "quick_invite": {
      visible: () => !window.inExternalSpace && needShowIvite()
    },  //添加和邀请同事
    "quick_team": {
      visible: (window.TEAMS?.currentUser?.admin || window.TEAMS?.globalConfig?.createteam_permission != '1') &&
        needShowTenant() && canCreateTeams(),
    },  //创建或加入团队
    "quick_contact": { visible: !window.inExternalSpace },  //通讯录
    "quick_org": {
      visible: !window.inExternalSpace,
    },  //组织架构
    "quick_profile": {
      visible: !window.inExternalSpace && !(window.TEAMS?.currentUser?.detachadmin === "1")
    },  //个人设置
    "quick_lanset": { visible: !window.inExternalSpace },  //语言设置
    "quick_changePass": { visible: !window.inExternalSpace },  //密码设置
    "quick_changeTrans": { visible: true },  //翻译模式 Icon-N-Translationmode 127357
    "quick_manager": { visible: !window.inExternalSpace },  //后台管理中心
    "quick_importAndExport": { visible: !window.inExternalSpace },  //导入导出记录
    "quick_changeNav": { visible: !window.inExternalSpace },  //显示设置
    "quick_clean": { visible: true },  //清除缓存
    "quick_logout": { visible: needShowLogout() },  //退出系统
    "quick_switch": { visible: false, }, //切换主次身份
    "quick_up_down": { visible: false },  //文件传输菜单
    "quick_lock": { visible: true },
    //PC客户端显示
    "quick_browser": { visible: inPCClient() },  //从浏览器打开
    //公有云
    "quick_goods": { visible: !isPrivateEnv() },  //推荐拿福利
    "quick_client": { visible: !isPrivateEnv() },  //企业及微信终端
    "quick_wechat": { visible: !isPrivateEnv() },  //微信号
    //私有化部署菜单
    "quick_download": { visible: isPrivateEnv() },  //终端下载
    "regular": { visible: true }
  }
  return data.filter((item) => {
    return visibleMap[item.menuKey] ?
      (
        typeof visibleMap[item.menuKey].visible === 'function' ?
          visibleMap[item.menuKey].visible() :
          visibleMap[item.menuKey].visible
      ) :
      true
  })
}

const navMenus: any = {
  MAIN_NAVI: [],
  NAVIGATION: [],
  MORE: []
};
const localNavMenus = localStorage.getItem(`LAYOUT_NAV_MENU_${window.TEAMS.currentTenant?.tenantKey}_${window.TEAMS.currentUser?.id}`);
if (localNavMenus) {
  try {
    const menus = JSON.parse(localNavMenus);
    navMenus.NAVIGATION = menus.NAVIGATION || [];
    navMenus.MORE = menus.MORE || [];
    navMenus.MAIN_NAVI = menus.MAIN_NAVI || [];
  } catch (e) {
  }
}

const iconInfo = getIconInfo("40");


export class HeaderMenuStore {
  beforeUpdateFastCreateMenus: any = null;
  beforeUpdateAppAllMenus: any = null;
  beforeUpdateAppMenus: any = null;
  beforeUpdateQuickMenus: any = null;
  @observable menuEntrances: QuickMenuItemType[] = [];//快捷新建菜单
  customAPPmenus: appMenuItemType[] = [];//用户自定义显示应用菜单
  @observable allAppMenusRefreshKey = "";
  allAppMenus: any = [];//所有应用
  allAppMenusIdMap: any = {};
  frequentlyUseMenus: any[] = [];//常用应用
  @observable frequentlyMenuWidth = "100%";
  @observable createMenus: any = [];//快捷新建菜单
  @observable quickMenus: any = [];//快捷菜单 （弃用）
  @observable navMenusLoaded: boolean = false;

  @observable navMainMenusKey = "";
  navMainMenus: NavMenuItem[] = navMenus.MAIN_NAVI;//后台管理中心配置的导航菜单，用于替换原快捷菜单以及新建、帮助中心
  @observable navMenusKey = "";
  navMenus: NavMenuItem[] = navMenus.NAVIGATION;//后台管理中心配置的导航菜单，用于替换原快捷菜单以及新建、帮助中心
  @observable moreNavMenusKey = "";
  moreNavMenus: NavMenuItem[] = navMenus.MORE;//更多导航菜单

  menuVisible: any = {};//导航菜单中需要单独控制显示得菜单统一放到这里
  @observable countTabValues: any = [];//事项统计数据
  @observable helpPopVisible: boolean = false;//快捷菜单
  @observable quickPopVisible: boolean = false;//快捷菜单
  @observable activeShowMenus: appMenuItemType[] = [];//菜单outside
  @observable appMenuLoaded: boolean = false;
  showNoAppNotify = false;
  @observable isOtherUser: boolean = !!window.TEAMS?.eworkspace; //是否是下属空间
  @observable otherUserInfo: any = {}; //下属空间信息
  @observable showImTab: any = window.TEAMS?.showImTab || false;
  @observable currentUserName: any = '';

  @observable tenantLogo = {
    logoUrl: "",
    logoClickUrl: ""
  }
  @observable originTenantLogo = {
    logoUrl: "",
    logoClickUrl: ""
  }
  @observable avatarPreviewUrl = '';

  @observable createMenuSetting: any = {
    quickIcon: {
      "path": "#icon-Approval-process-o",
      "style": {
        "fontSize": 18,
        "radius": "9px",
        "color": "#ffffff",
        "fillType": "backgroundColor",
        "bgColor": iconInfo.color
      }
    },
    name: getLabel('19210', "设置"),
    module: 40,
  };//快捷新建菜单设置

  @observable portalNameDisplay: boolean = false; // 门户pc显示应用名称
  @observable displayCommonApp: boolean = false; // 是否显示常用应用

  //主题配置
  @observable logoLocal = window.TEAMS?.theme?.logoLocal === undefined ? (isPrivateEnv() ? 1 : 0) : window.TEAMS?.theme?.logoLocal;  //私有环境logo显示在前
  @observable navIconType: IconShowType = window.TEAMS?.theme?.navIconType || 0;  //应用菜单图标显示方式 线性/非线性
  @observable navMenuDisplayType = window.TEAMS?.theme?.navMenuDisplayType || 0;  //应用文字图标菜单显示方式
  @observable toolIcoStyle: IconShowType = Number(window.TEAMS?.theme?.topicLayout) === 2 ?   //工具栏菜单图标显示方式
    (!window.TEAMS?.theme?.toolIcoStyle && window.TEAMS?.theme?.toolIcoStyle !== IconShowType.SOLID ?
      IconShowType.LINEAR :
      window.TEAMS?.theme?.toolIcoStyle
    ) :
    (!window.TEAMS?.theme?.navIconType && window.TEAMS?.theme?.navIconType !== IconShowType.SOLID ?
      IconShowType.LINEAR :
      window.TEAMS?.theme?.navIconType
    );
  @observable searchShowType?: SearchShowType = window.TEAMS?.theme?.searchShowType || SearchShowType.FLOAT;  //导航快捷搜索显示方式

  //快捷搜索
  @observable searchTypeLoading = true;
  @observable searchValue = "";
  @observable quickSearchTypeId = "";
  @observable quickSearchEnable = false;
  @observable quickSearchList: QuickSearchItem[] = [];
  @observable quickSearchLoading = false;
  @observable searchRecommendDisable: string = window.TEAMS?.userConfig ? window.TEAMS?.userConfig['system.nav.quicksearch.recommend.disable'] || "" : "";
  @observable searchHistoryList: any[] = [];
  @observable searchRecommendList: any[] = [];

  //导航右侧菜单显示状态
  quickVisibilityVisible = false;

  //导航logo显示宽度
  @observable logoWidth = 0;

  //构建团队应用权限
  @observable appCreatePermission = !!window.TEAMS?.currentUser?.admin;

  @action
  init = () => {
    this.getHrAvatar();
    this.getCurrentUserName();
    // this.getMenuEntrances();
    this.getTenantLogo()

    //延迟3s加载应用菜单
    const isSpecialTheme = window.TEAMS?.theme?.themeType === 'feature';
    const navRenderDelayTime = isSpecialTheme ? (
      window.ecode_layoutSpecailNavDelayTime === undefined ? 2000 : window.ecode_layoutSpecailNavDelayTime
    ) : (
      window.ecode_layoutNavDelayTime === undefined ? 3000 : window.ecode_layoutNavDelayTime
    );
    let timer = setTimeout(() => {
      if (!window.inExternalSpace && !this.isOtherUser) {
        this.checkInitModule()  //新增模块数据初始校验
        if (!window.ecode_layoutNavNotLoad) {
          !this.allAppMenus?.length && this.getAllAppMenus();
        }
        this.getFrequentlyUseMenus();
        this.getCreateMenus();
        this.getHomeConfig();
        this.getDisplayCommonConfig();
      }
      if (this.isOtherUser) {
        this.getOtherUserMenus(window.TEAMS?.eworkspace?.userId);
      }
      if (!window.ecode_layoutNavNotLoad) {
        this.getCustomAPPmenus();
      }
      this.loadCreateAppPermission();
      this.getQuickMenus();
      clearTimeout(timer)
    }, this.isOtherUser ? 0 : navRenderDelayTime)
  }
  @action
  getCurrentUserName = () => {
    window.TEAMS?.ready?.('currentSimpleEmployee', {
      success: (res: any) => {
        runInAction(() => {
          if (res.data?.username) {
            this.currentUserName = res.data.username;
          } else {
            this.currentUserName = window.TEAMS?.currentUser?.username || '';
          }
        })
      },
      failed: (error: any) => {
        runInAction(() => {
          this.currentUserName = window.TEAMS?.currentUser?.username || '';
        })
      },
    });
  }
  @action
  checkInitModule = () => {
    API.checkInitModule()
      .then((result: any) => {
        runInAction(() => {

        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  @action
  getHomeConfig = () => {
    API.queryAppConfigByKey({
      configKey: 'portal_name_display',
    }).then((res: any) => {
      if (res && res.data) {
        runInAction(() => {
          this.portalNameDisplay = res.data.configValue === '1';
        })
      }
    })
  }

  @action
  getDisplayCommonConfig = () => {
    API.queryEmpConfigByKey({
      configKey: 'showCommonApps',
    }).then((res: any) => {
      if (res && res.data) {
        runInAction(() => {
          this.displayCommonApp = res.data.configValue === '1';
        })
      }
    })
  }

  @action
  getHrAvatar = () => {
    API.getHrAvatar()
      .then((result: any) => {
        runInAction(() => {
          if (result && result.data && result.data.avatar) {
            this.avatarPreviewUrl = result.data.avatar.previewUrl;
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  @action
  exchangeTenantLogo = (themeStyle: string, toolIcoColor?: number) => {
    runInAction(() => {
      if (themeStyle === 'light' || (themeStyle === 'client' && Number(toolIcoColor) === 1)) {
        this.tenantLogo.logoUrl = this.originTenantLogo.logoClickUrl
      } else {
        this.tenantLogo.logoUrl = this.originTenantLogo.logoUrl
      }
    });
  }
  @action
  changeHelpPopVisible = (visible: boolean) => {
    this.helpPopVisible = visible;
  }
  @action
  changeQuickPopVisible = (visible: boolean) => {
    this.quickPopVisible = visible;
  }
  @action
  getCustomAPPmenus = (id?: string) => {//from //下属空间功能中使用，标志位
    // this.customAPPmenus = mockData.empMenusContext;
    let params = {};
    if (this.isOtherUser) {
      params = { userId: id || window.TEAMS?.eworkspace?.userId };
    }
    API.getCustomAPPmenus(params)
      .then((result: any) => {
        if (result) {
          let customAppMenus: appMenuItemType[] = [];
          let activeMenus: appMenuItemType[] = [];

          result.data.map((it: any) => {
            customAppMenus.push({ ...it })
            if (it.active) {
              if (this.isOtherUser) {
                activeMenus.push(RoutePathControlByOther({ ...it, isInit: true }, id!))
              } else {
                activeMenus.push({ ...it, isInit: true })
              }
            }
          });

          // if (this.beforeUpdateAppMenus) {
          //   customAppMenus = this.beforeUpdateAppMenus(customAppMenus)
          // }

          this.customAPPmenus = customAppMenus;
          this.updateActiveShowMenus(activeMenus)

          runInAction(() => {
            this.appMenuLoaded = true;
          })

          const ee = window.weappLayout.default && window.weappLayout.default.ee || window.weappLayout.ee;
          ee.emit('layout.refreshMenuLayout');
          ee.emit('layout.controlActiveMenu');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  @action
  updateActiveShowMenus = (data: appMenuItemType[]) => {
    // this.customAPPmenus = mockData.empMenusContext;
    let activeShowMenus: appMenuItemType[] = [];
    (data || []).forEach((item) => {
      item = this.buildAppMenuParams(item);
      if (!(!item.active && !!hiddenNavigationList.find((pool: any) => window.location.pathname.replace(layoutPublicUrl, '').indexOf(pool) === 0))) {
        activeShowMenus.push(item);
      }
    })
    if (this.beforeUpdateAppMenus) {
      activeShowMenus = this.beforeUpdateAppMenus(activeShowMenus)
    }
    this.activeShowMenus = filterApp(activeShowMenus);

    const currentActiveData = getMaxLengthSameStr(activeShowMenus, window.location.pathname.replace(layoutPublicUrl, '') || '/') as any;
    updateMenuInfoData('navAppMenusData', activeShowMenus);//更新sdk中的导航显示菜单
    updateMenuInfoData('navAppMenuActiveData', currentActiveData);//更新sdk中的导航选中菜单
  }

  @action
  hanldeFilterMenu = (data: string, allAppMenusList: any) => {
    let filterMenuIndex: any = []
    let filterMenu: any = []
    if (data) {
      let allAppMenus: any = JSON.parse(JSON.stringify(toJS(allAppMenusList)))
      // console.log(`filter allAppMenus`, allAppMenus)
      allAppMenus.map((menuColum: any, index: number) => {
        console.log(` menuColum`, menuColum)
        menuColum.data.map((group: appMenuGroupType, outIndex: number) => {
          group.menus.map((item: appMenuItemType, innerIndex: any) => {
            if (item && item.menuname) {
              if (item?.menuname.toLowerCase().indexOf(data.toLowerCase()) !== -1) {
                menuColum.show = true
                group.show = true
                item.show = true
              } else {
                menuColum.show = false
                group.show = false
                item.show = false
              }
            }
          })
        })
      })
      allAppMenus.map((menuColum: any, index: number) => {
        menuColum.data.map((group: appMenuGroupType, outIndex: number) => {
          group.menus.map((item: appMenuItemType, innerIndex: any) => {
            if (item && item.menuname) {
              if (item.show) {
                menuColum.show = true
                group.show = true
              }
            }
          })
        })
      })
      return allAppMenus
    } else {
      return null
    }
  }

  //外部链接菜单
  @action
  checkAppMenus = (menus: any, type?: string) => {
    menus && menus.forEach((menu: any) => {
      this.buildAppMenuParams(menu, type)
    })
    return menus;
  }

  //外部链接菜单
  buildAppMenuParams = (menu: any, type?: string) => {
    if (menu.module === 'freeUrl' || menu.module === 'freeIntLogin') {
      const { url = '' } = menu;
      if (url.indexOf('/auth/third?app_key') != -1 && url.indexOf('redirect_uri') != -1) {
        let redirect_url = url.match(/redirect_uri=(\S*)/)[1];
        if (redirect_url.indexOf('https') != -1) {
          menu.iframeSrc = url;
        } else {
          menu.path = url;
          menu.needOpenNewPage = true;
        }
      } else if (url.indexOf('/sp/integration/loginSingle') != -1) {
        menu.path = url;
        menu.needOpenNewPage = true;
      } else {
        if (url.indexOf('/login2third.html?appId') != -1) {
          menu.path = url;
          menu.needOpenNewPage = true;
        } else {
          if (url.indexOf('https://') != -1) {
            menu.iframeSrc = url;
          } else if (url.indexOf('http://') != -1) {
            menu.path = url;
            menu.needOpenNewPage = true;
          } else if (url.startsWith('/customurl/') !== -1) {
            menu.path = url;
          }
        }
      }
      if (type && type === 'allApps' && window.location.pathname.replace(layoutPublicUrl, '').indexOf(menu.path as string) != -1) {
        mainStore.setIframeSrc(url);
      }
    }
    return menu;
  }

  @action
  getFrequentlyUseMenus = () => {
    API.getApplicationsFrequentlyUsed().then((result: any) => {
      if (result && result.data) {
        this.frequentlyUseMenus = result.data;
      }
    });
  }

  @action
  updateFrequentlyMenuWidth = (width: string) => {
    this.frequentlyMenuWidth = width;
  }

  @action
  getAllAppMenus = (callback?: Function) => {
    API.getApplications()
      .then((result: any) => {
        if (result && result.data) {
          let menuIdMap: any = {};
          result.data.forEach((group: any) => {
            // group.menus = this.checkAppMenus(group.menus, 'allApps');
            if (group.menus){
              group.menus = filterApp(group.menus);
              group.menus.forEach((item: any) => {
                this.buildAppMenuParams(item, 'allApps');
                //生成提供常用菜单id映射的应用map
                menuIdMap[item.id] = item;
              });
            }
          });
          let allmenus = controlGroupData(result.data)

          setBrowserTitle(allmenus);
          if (!isPreviewToolMenu()) {
            mainStore.initPayTip(allmenus);
          }

          if (this.beforeUpdateAppAllMenus) {
            allmenus = this.beforeUpdateAppAllMenus(allmenus)
          }
          // 新增模块暂时编入最后分组
          this.allAppMenus = allmenus;
          this.allAppMenusIdMap = menuIdMap;

          // runInAction(() => {
          //   this.allAppMenusRefreshKey = `app_menu_${new Date().getTime()}`
          // })

          updateMenuInfoData('allAppMenusData', this.allAppMenus)

          callback?.();

          const ee = window.weappLayout.default && window.weappLayout.default.ee || window.weappLayout.ee;
          ee.emit('layout.controlActiveMenu')

          if (isE10Self()) {
            if (!this.showNoAppNotify && !result.data?.length) {
              ee.emit('layout.showNoAppNotify');
              this.showNoAppNotify = true;
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  @action
  getOtherUserMenus = (id: string) => {
    API.getApplications({ userId: id })
      .then((result: any) => {
        runInAction(() => {
          if (result) {
            if (result.data) {
              let data = [...result.data]
              data = data.map((item: any) => {
                let menus = (item.menus || []).map((menu: any) => {
                  return RoutePathControlByOther(menu, id)
                })

                //他人空间暂时屏蔽我的日程和crm首页
                menus = menus.filter((item: any) => {
                  return item.module !== "calendar" && item.module !== "crmHomeCustom";
                })

                //关注人的下属空间只显示日报
                if (mainStore.otherUserPermission.isFollow && !mainStore.otherUserPermission.isSub) {
                  menus = menus.filter((item: any) => {
                    return item.module === "blog";
                  })
                }

                return { ...item, menus }
              })

              let allmenus = controlGroupData(data)
              this.allAppMenus = allmenus;
              this.allAppMenusRefreshKey = `app_menu_${new Date().getTime()}`

              //下属空间  需要从更多菜单中取名称替换activemenu中的名称（处理分权下级部门显示问题）
              if (this.activeShowMenus?.[0]) {
                this.allAppMenus.forEach?.((items: any) => {
                  items?.forEach?.((menus: any) => {
                    menus?.menus?.forEach?.((menu: any) => {
                      if (menu.module === this.activeShowMenus[0]?.module && (menu.shortname || menu.menuname)) {
                        this.activeShowMenus[0].menuname = menu.shortname || menu.menuname
                      }
                    })
                  })
                })
                this.activeShowMenus = [...this.activeShowMenus];
              }
            }
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  @action
  getOtherInfo = (id: string, userInfo?: any) => {//下属空间系列操作
    this.isOtherUser = true;
    this.updateOtherUserInfo(userInfo);
  }
  @action
  getCreateMenus = () => {
    API.getEmpMenuEntrances()
      .then((result: any) => {
        if (result) {
          let createMenus = result.menuEntrances.map((menu: any) => {
            let icon: any = {
              "path": "#icon-custom01-o",
              "style": {
                "fontSize": 18,
                "radius": "9px",
                "color": "#ffffff",
                "fillType": "backgroundColor",
                "borderColor": "transparent",
                "bgColor": "#ffcd50"
              }
            };

            if (menu.quickIcon) {
              try {
                icon = JSON.parse(menu.quickIcon);
                // 兼容老数据保存生成了#undefined的数据 ---start
                if (icon.path === '#undefined') {
                  icon.path = '#icon-custom01-o';
                }

                if (icon.style && !icon.style?.bgColor) {
                  icon.style.bgColor = "#ffcd50";
                }
                // 兼容老数据保存生成了#undefined的数据 ---end
              } catch (error) {

              }
            } else if (menu.moduleStr) {
              const iconInfo = getIconInfo(menu.moduleStr);
              icon = {
                "path": "#" + (iconInfo.icon_line ? iconInfo.icon_line : 'icon-custom01-o'),
                "style": {
                  "fontSize": 18,
                  "radius": "9px",
                  "color": "#ffffff",
                  "fillType": "backgroundColor",
                  "bgColor": iconInfo.color ? iconInfo.color : "#ffcd50"
                }
              }
            }

            let url = menu.quickUrl;
            try {
              if (!(menu.quickType === QuickMenuType.CUSTOM_URL || menu.quickType === QuickMenuType.LINE)) {
                url = JSON.parse(menu.quickUrl);
              }
            } catch (error) {

            }

            return {
              ...menu,
              quickUrl: url,
              quickIcon: icon
            }
          });


          let settMenu = [{ quickType: QuickMenuType.LINE }, this.createMenuSetting];
          const hasData = createMenus.find((menu: any) => menu.quickType !== QuickMenuType.LINE);
          if (hasData) {
            settMenu = [{ quickType: QuickMenuType.LINE }, this.createMenuSetting];
          } else {
            createMenus = [];
            settMenu = [this.createMenuSetting]
          }

          runInAction(() => {
            //eb复写交互
            if (this.beforeUpdateFastCreateMenus) {
              createMenus = this.beforeUpdateFastCreateMenus(createMenus);
            }
            this.createMenus = [...createMenus, ...settMenu];
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  @action
  getQuickMenus = () => {
    const list: any = [];
    const externalMenusModules = [
      'quick_client',
      'quick_wechat',
      'quick_team',
      'quick_goods',
      'quick_logout',
    ];
    let externalMenus: any = [];
    // debugger
    let quickMenus = [];
    mockData().quickMenus.forEach((group: any) => {
      let menus: any = [];

      group.forEach((m: any) => {
        if (window.inExternalSpace) {
          if (externalMenusModules.includes(m.module)) {
            externalMenus.push(m);
          }
        } else {
          if (m.module == 'quick_org') {  //TODO
            if (window.TEAMS?.currentUser?.admin) {
              menus.push(m)
            }
          } else if (m.module == 'quick_team') {  //TODO
            if (window.TEAMS?.currentUser?.admin || window.TEAMS?.globalConfig?.createteam_permission != '1') {
              menus.push(m)
            }
          } else {
            menus.push(m)
          }
        }
      })

      list.push(menus);
    })
    quickMenus = window.inExternalSpace ? [externalMenus] : list;
    if (this.beforeUpdateQuickMenus) {
      quickMenus = this.beforeUpdateQuickMenus(quickMenus);
    }
    this.quickMenus = quickMenus;
  }

  @action
  saveFeedBackMsg = (value: any) => {
    // console.log('saveFeedBackMsg store', value)
    API.saveFeedBackMsg(value)
      .then((result: any) => {
        runInAction(() => {
          if (result) {
            message({
              type: "success",
              content: getLabel('62283', '感谢您的宝贵意见！'),
            });
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  @action
  loadNavMenus(callback?: Function) {
    if (this.navMenusLoaded) {
      callback && callback({
        MAIN_NAVI: this.navMainMenus,
        NAVIGATION: this.navMenus,
        MORE: this.navMenus
      });
      return;
    };
    API.getNavMenuList().then(({ status, data }) => {
      if (status) {
        // let data = mockData().navMenus;
        let mainMenus = data.MAIN_NAVI || [];
        let navMenus = data.NAVIGATION || [];
        let moreNavMenus = data.MORE || [];

        this.navMainMenus = mainMenus;
        this.navMenus = filterMainNav(navMenus);
        this.moreNavMenus = moreNavMenus;

        LayoutSDK.setDataByKey({
          key: 'navMenuData',
          value: toJS({
            navMainMenus: this.navMainMenus,
            navMenus: this.navMenus,
            moreNavMenus: this.moreNavMenus,
          }),
          source: 'layout'
        })

        runInAction(() => {
          this.navMainMenusKey = `refresh_key_${new Date().getTime()}`
          this.navMenusKey = `refresh_key_${new Date().getTime()}`
          this.moreNavMenusKey = `refresh_key_${new Date().getTime()}`
          this.navMenusLoaded = true;
        })

        clearCookieByName('intunifyauth_client');

        //本地缓存导航菜单
        try {
          localStorage.setItem(`LAYOUT_NAV_MENU_${window.TEAMS?.currentTenant?.tenantKey}_${window.TEAMS?.currentUser?.id}`, JSON.stringify({
            MAIN_NAVI: data.MAIN_NAVI,
            NAVIGATION: filterMainNav(data.NAVIGATION),
            MORE: data.MORE
          }));
        } catch (e) {
          //@ts-ignore
          if (e.name == 'QuotaExceededError' || e.name == 'NS_ERROR_DOM_QUOTA_REACHED') {
            window.ePassport?.showClearPrompt?.();
          }
        }

      }
      callback && callback(data);
    })
  }

  @action
  refreshNavMenu = () => {
    this.navMenusKey = `refresh_key_${new Date().getTime()}`
    this.moreNavMenusKey = `refresh_key_${new Date().getTime()}`
  }

  @action
  refreshAppMenu = () => {
    this.allAppMenusRefreshKey = `app_menu_${new Date().getTime()}`;
  }

  @action
  changeLogoLocal(logoLocal: number) {
    this.logoLocal = logoLocal;
  }

  @action
  changeNavIconType(navIconType: number) {
    this.navIconType = navIconType;
  }

  @action
  changeNavMenuDisplayType(navMenuDisplayType: number) {
    this.navMenuDisplayType = navMenuDisplayType;
  }

  @action
  changeToolIcoStyle = (toolIcoStyle: IconShowType) => {
    this.toolIcoStyle = toolIcoStyle;
  }

  @action
  changeSearchShowType = (searchShowType: SearchShowType) => {
    this.searchShowType = searchShowType;
  }

  @action
  loadQuickSearchEnable = (callback?: Function) => {
    API.queryQuickNeedShow().then(({ status, data }) => {
      if (status) {
        runInAction(() => {
          this.quickSearchEnable = data;
          if (data) {
            callback?.();
          } else {
            this.searchTypeLoading = false;
          }
        })
      }
    });
  }

  @action
  loadQuickSearchList = () => {
    if (this.quickSearchEnable) {
      API.getQuickSearchList().then(({ status, data }) => {
        if (status) {
          if (data) {
            runInAction(() => {
              this.searchTypeLoading = false;
              this.quickSearchList = data;
              if (data.length && !this.quickSearchTypeId) {
                this.quickSearchTypeId = data[0].id;
              }
            })
          }
        }
      });
    }
  }

  @action
  addQuickSearchHistory = (keyword: string, callback?: Function) => {
    API.addQuickSearchHistory(keyword).then(({ status }) => {
      if (status) {
        callback && callback();
      }
    });
  }

  @action
  querySearchHistory = () => {
    this.quickSearchLoading = true;
    API.getQuickSearchHistory().then(({ status, data }) => {
      runInAction(() => {
        if (status) {
          this.searchHistoryList = data;
        }
        this.quickSearchLoading = false;
      })
    })
  }

  @action
  clearSearchHistory = (callback: Function) => {
    API.clearSearchHistory().then(({ status }) => {
      if (status) {
        callback && callback();
      }
    })
  }

  @action
  deleteSearchHistory = (id: string, item: any) => {
    this.quickSearchLoading = true;
    API.deleteSearchHistory(id).then(({ status }) => {
      runInAction(() => {
        if (status) {
          message({ type: "success", content: getLabel('61245', "删除成功") });
          // this.querySearchHistory();
          this.searchHistoryList.splice(this.searchHistoryList.indexOf(item), 1);
          this.quickSearchLoading = false;
        }
      })
    })
  }

  //保存或更新个人偏好设置
  saveOrUpdateConfig = (key: string, value: string, callback?: Function) => {
    const { userConfig } = window.TEAMS;
    if (userConfig[key]) {
      API.updateUserConfig({
        config: {
          id: userConfig[key].id,
          configKey: key,
          configValue: value
        }
      }).then((status) => {
        if (status) {
          userConfig[`${key}`] = value;
          callback && callback();
        }
      });
    } else {
      API.saveUserConfig({ config: { configKey: key, configValue: value } }).then((status) => {
        if (status) {
          userConfig[`${key}`] = value;
          callback && callback();
        }
      });
    }

  }

  @action
  saveSearchRecommend = (disable: string) => {
    this.saveOrUpdateConfig('system.nav.quicksearch.recommend.disable', disable, () => {
      runInAction(() => {
        message({ type: "success", content: getLabel('32223', "保存成功") })
        this.searchRecommendDisable = disable;
      })
    });
  };

  @action
  queryHotSearch = _.debounce((key: string) => {
    if (!(window.TEAMS?.isDisplayModule?.('esearch'))) {
      return;
    }
    runInAction(() => {
      this.quickSearchLoading = true;
    })
    API.queryHotSearch(key).then(({ status, data }) => {
      if (status) {
        runInAction(() => {
          this.quickSearchLoading = false;
          this.searchRecommendList = data;
        })
      }
    })
  }, 200)

  @action
  clearHotSearch = () => {
    this.searchRecommendList = [];
  }

  @action
  updateSearchValue = (value: string) => {
    this.searchValue = value;
  }

  @action
  clearSearchValue = () => {
    this.searchValue = "";
  }

  @action
  updateQuickSearchTypeId = (id: string) => {
    this.quickSearchTypeId = id;
  }

  @action
  updateOtherUserInfo = (otherUserInfo: any) => {
    this.otherUserInfo = otherUserInfo;
    if (window.TEAMS.eworkspace) {
      window.TEAMS.eworkspace.user = otherUserInfo;
    }
  }

  //导航菜单显示权限
  @action
  getMenuVisible = (callback?: Function) => {
    const menuKeys = Object.keys(MailTypesMenuKeyMap);
    const mails = Object.values(MailTypesMenuKeyMap);

    Promise.all([
      API.checkoutMenuVisibilityVisible(),
      API.mailVisibleBatch(),
      // ...mails.map((code) => API.mailVisible(code))
    ]).then(([visibilityRes, ...mailResArr]) => {

      //可视化修改模式
      if (visibilityRes.status) {
        let auth = false;
        visibilityRes.data && visibilityRes.data.length && visibilityRes.data.forEach((item: any) => {
          if (item.code === "ecode_component") {
            auth = true;
          }
        })
        this.quickVisibilityVisible = auth;
      }

      //集成邮箱
      let mailRes = mailResArr[0];
      if (mailRes.status && mailRes.data) {
        let menuVisible = {};
        Object.keys(mailRes.data).forEach((code) => {
          if (mails.indexOf(code) !== -1 && menuKeys[mails.indexOf(code)]) {
            menuVisible[menuKeys[mails.indexOf(code)]] = mailRes.data[code]
          }
        })
        this.menuVisible = menuVisible;
        console.log(menuVisible)
      }

      //集成邮箱
      // let menuVisible = {};
      // mailResArr.forEach((res, index) => {
      //   if (res.status) {
      //     menuVisible[menuKeys[index]] = !!res.data?.visible;
      //   }
      // })
      // this.menuVisible = menuVisible;

      const ee = window.weappLayout.default && window.weappLayout.default.ee || window.weappLayout.ee;
      ee.emit('layout.refreshMenuLayout');

      callback?.();
    }).catch(() => {
      callback?.();
    })
  }

  @action
  updateNavMenuItemByMenuKey = (menuKey: string) => {
    [...this.navMainMenus, ...this.navMenus, ...this.moreNavMenus].forEach((menu: NavMenuItem) => {
      if (menu.menuKey === menuKey) {
        switch (menu.menuKey) {
          //需要特殊处理的菜单
          case "quick_concern":  //关注事项
            mainStore.getCountTabValues();
            break;
          //标准菜单更新的菜单增加标记
          default:
            if (menu.cornerMarkSetting) {
              menu.cornerMarkSetting._refreshTag = (menu.cornerMarkSetting._refreshTag || 0) + 1;
              this.navMenusKey = `refresh_key_${new Date().getTime()}`;
              this.moreNavMenusKey = `refresh_key_${new Date().getTime()}`;
            }
        }
      }
    })
  }

  @action
  setLogoWidth = (width: number) => {
    this.logoWidth = width;
  }

  @action
  generateNewTicket = (callback?: (url: string) => void) => {
    API.generateNewTicket().then(({ status, data, msg }) => {
      if (status) {
        callback?.(data?.url)
      }
    })
  }

  @action
  loadCreateAppPermission = () => {
    if (!window.TEAMS?.currentUser?.admin) {
      mainAPI.loadPermissions("AppManage").then(({ status, msg, data }) => {
        runInAction(() => {
          if (status) {
            data?.forEach?.((item: any) => {
              if (item.code === 'createCustomApplication') {
                this.appCreatePermission = true
              }
            })
          }
        })
      })
    }
  }

  @action
  getDefaultTenantLogo = () => {
    //接口请求失败时采用默认图标
    this.tenantLogo.logoUrl = isPrivateEnv() ?
      `${layoutPublicStatic}/static/img/global/ecology-logo_white@2x.png` :
      `${layoutPublicStatic}/static/img/global/eteams-logo_white@2x.png`
    this.tenantLogo.logoClickUrl = isPrivateEnv() ?
      `${layoutPublicStatic}/static/img/global/ecology-logo_black@2x.png` :
      `${layoutPublicStatic}/static/img/global/eteams-logo_black@2x.png`
    this.originTenantLogo.logoUrl = this.tenantLogo.logoUrl
    this.originTenantLogo.logoClickUrl = this.tenantLogo.logoClickUrl
  }

  @action
  getTenantLogo = () => {
    if (window?.TEAMS?.ready && typeof window.TEAMS.ready === 'function') {
      window.TEAMS.ready('tenantLogo', {
        success: (data: any) => {
          runInAction(() => {
            const tenantLogo = window.TEAMS.tenantLogo;
            this.tenantLogo.logoUrl = tenantLogo.logoUrl
            this.tenantLogo.logoClickUrl = tenantLogo.logoClickUrl
            this.originTenantLogo.logoUrl = tenantLogo.logoUrl
            this.originTenantLogo.logoClickUrl = tenantLogo.logoClickUrl
            this.exchangeTenantLogo(window?.TEAMS?.theme?.topicStyle, window?.TEAMS?.theme?.toolIcoColor)
          })
        },
        failed: (data: any) => {
          runInAction(() => {
            this.getDefaultTenantLogo()
            this.exchangeTenantLogo(window?.TEAMS?.theme?.topicStyle, window?.TEAMS?.theme?.toolIcoColor)
          })
        },
      })
    } else {
      this.getDefaultTenantLogo()
      this.exchangeTenantLogo(window?.TEAMS?.theme?.topicStyle, window?.TEAMS?.theme?.toolIcoColor)
    }
  }

}

let instance = new HeaderMenuStore();

//TODO 火狐浏览器下特色主题偶现加载不出应用菜单-排除出是headerMenuStore初始化了两次，特色主题下的组件用了另一份store没有应用数据导致
const isSpecialTheme = window.TEAMS?.theme?.themeType === 'feature';
if (isFirefox() && isSpecialTheme) {
  if (window.LAYOUT_PREFIX_HEADERMENUSTORE) {
    instance = window.LAYOUT_PREFIX_HEADERMENUSTORE;
  } else {
    window.LAYOUT_PREFIX_HEADERMENUSTORE = instance;
  }
}

export default instance;
